import styled from 'styled-components'

export const Title = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  max-height: 312px;
  margin-top: ${props => props.theme.spacing.sp8};
  overflow-x: hidden;
  overflow-y: auto;
`
